module.exports = __webpack_public_path__ + "static/img/92.911ce075.jpg";